<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h11">Glossaire des termes de marine</h1>
<p class="p5"><span class="t7"> </span></p>
<p class="p7">Abordage : Assaut d’un navire à un autre.</p>
<p class="p7"><span class="t8">Affaler : faire descendre (des voiles), c’est le contraire de ‘hâler’.</span></p>
<p class="p7"><span class="t8">Armement : tout ce qui est nécessaire à la navigation, c’est-à-dire la totalité des instruments dont un navire est muni.</span></p>
<p class="p7"><span class="t8">Aussière (ou haussière) : gros cordage employé pour l’amarrage et le remorquage.</span></p>
<p class="p7"><span class="t8">Bâbord : partie du navire située à gauche en faisant face à l’avant (opposé de tribord).</span></p>
<p class="p7"><span class="t8">Barre : organe de commande du gouvernail, sert à diriger le navire.</span></p>
<p class="p7"><span class="t8">Bastingage : muret en bois ou en fer autour du pont supérieur d’un navire.</span></p>
<p class="p7"><span class="t8">Biscuit de mer : sorte de galette plate que mangent les marins au long cours ; ceux de la Royal Navy étaient fait de farine complète (avec son).</span></p>
<p class="p6"><span class="t8">Bordée :</span></p>
<p class="p7"><span class="t8">1. Ensemble des canons d’un des côtés du navire et, par extension, leur décharge simultanée.</span></p>
<p class="p7"><span class="t8">2. Route faite par un navire entre deux changements de cap, en gardant le vent du même côté.</span></p>
<p class="p7"><span class="t8">Bosco (argot marin) : maître de manœuvre (marine de guerre), ou maître d’équipage (marine de commerce).</span></p>
<p class="p7"><span class="t8">Cale : endroit sous le pont où sont stockées les marchandises.</span></p>
<p class="p7"><span class="t8">Carré : pièce à vivre d’un bateau.</span></p>
<p class="p7"><span class="t8">Château : superstructure de la partie centrale du pont supérieur, d’un côté à l’autre du navire.</span></p>
<p class="p7"><span class="t8">Cloche : elle rythme la vie à bord en marquant les principaux évènements de la journée. Objet emblématique d’un vaisseau au même titre que la figure de proue et que le pavillon, elle sonne les ‘quarts’ – car la journée est divisée.</span></p>
<p class="p7"><span class="t8">Compas : boussole d’un bateau.</span></p>
<p class="p7"><span class="t8">Coursive : terme générique pour désigner les passages étroits du navire (couloirs).</span></p>
<p class="p7"><span class="t8">Drisse : cordage ou palan servant à hisser une vergue, une corne, une voile.</span></p>
<p class="p7"><span class="t8">Dunette : pont surélevé à l’arrière d’un bateau, au-dessus du gaillard d’arrière</span></p>
<p class="p7"><span class="t8">Écoutille : ouverture rectangulaire pratiquée dans le pont pour accéder aux entreponts et aux cales.</span></p>
<p class="p7"><span class="t8">Embruns : poussière liquide arrachée par le vent à la crête des vagues.</span></p>
<p class="p7"><span class="t8">Encalminé : (en parlant d’un navire) immobilisé par manque de vent.</span></p>
<p class="p7"><span class="t8">Entrepont : espace compris entre la cale et le pont principal, au-dessus de la flottaison.</span></p>
<p class="p7"><span class="t8">Épissure : tressage d’éléments de cordages entre eux, pour les mettre bout à bout.</span></p>
<p class="p7"><span class="t8">Erre : vitesse conservée par un navire qui n’est plus propulsé par ses voiles.</span></p>
<p class="p7"><span class="t8">Feu de Saint-Elme : phénomène physique lumineux se produisant au sommet d’un mât dans certaines conditions météorologiques.</span></p>
<p class="p7"><span class="t8">Filière : cordage courant tout autour du pont servant de garde-corps – par mauvais temps, les hommes s’y retiennent pendant les forts mouvements de roulis et de tangage.</span></p>
<p class="p7"><span class="t8">Garcette : petit cordage court, généralement récupéré par l’équipage sur un cordage plus grand et usé, et qui sert le plus souvent à amarrer un des équipements (seau, casier, voile, etc.).</span></p>
<p class="p6"><span class="t8">Gaillard :</span></p>
<p class="p7"><span class="t8">1. Gaillard avant : pont surélevé à l’avant du navire.</span></p>
<p class="p7"><span class="t8">2. Gaillard arrière : au même niveau que le gaillard avant, mais situé à l’arrière du grand mât.</span></p>
<p class="p7"><span class="t8">Mâts :</span></p>
<p class="p7"><span class="t8">1. Grand mât, mât central.</span></p>
<p class="p7"><span class="t8">2. Mât de misaine, mât avant de tout voilier en ayant plus de deux.</span></p>
<p class="p7"><span class="t8">3. Mât d’artimon, mât situé le plus en arrière du bateau.</span></p>
<p class="p7"><span class="t8">Gréement : ensemble des cordages et poulies qui servent à établir et à manœuvrer les voiles.</span></p>
<p class="p7"><span class="t8">Hunier : voile supérieure portée au-dessus des voiles basses.</span></p>
<p class="p7"><span class="t8">Pavillon : drapeau (terme de marine).</span></p>
<p class="p7"><span class="t8">Perroquet : voile carrée située au-dessus du hunier.</span></p>
<p class="p7"><span class="t8">Pirate : hors-la-loi des mers.</span></p>
<p class="p7"><span class="t8">Pont : ‘plancher’ du navire.</span></p>
<p class="p7"><span class="t8">Poulaines : W-C. de l’équipage.</span></p>
<p class="p7"><span class="t8">Poupe : partie arrière d’un navire.</span></p>
<p class="p7"><span class="t8">Proue : partie avant d’un navire, au-dessus de l’étrave.</span></p>
<p class="p6"><span class="t8">Quart :</span></p>
<p class="p7"><span class="t8">1. Division du temps à bord.</span></p>
<p class="p7"><span class="t8">2. Période de service d’une bordée.</span></p>
<p class="p7"><span class="t8">Rambarde : garde-corps.</span></p>
<p class="p7"><span class="t8">Sonder : mesurer la profondeur d’eau.</span></p>
<p class="p7"><span class="t8">Tribord : côté droit du navire (opposé de bâbord).</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006.vue?f7952c10